import http from './http'

export function listRecurring() {
  return http.get('/recurring')
}

export function createRecurring(payload) {
  return http.post('/recurring', payload)
}

export function updateRecurring(id, payload) {
  return http.put(`/recurring/${id}`, payload)
}

export function deleteRecurring(id) {
  return http.delete(`/recurring/${id}`)
}
